import "../../../assets/presentation/components/design-system/colors/brand-blue-B2fmFOwx.css";
import "../../../assets/presentation/components/design-system/colors/brand-turquoise-STiiuhQL.css";
import "../../../assets/presentation/components/design-system/colors/brand-yellow-Dys7Nx9M.css";
import "../../../assets/presentation/components/design-system/colors/contextual-colors-CvvW0k3B.css";
import "../../../assets/presentation/components/design-system/colors/neutral-SlkQzpvW.css";
import "../../../assets/presentation/components/design-system/colors/product-pda9ByNF.css";
import "../../../assets/presentation/components/design-system/colors/support-BkXeoy3a.css";
import "../../../assets/presentation/components/design-system/design-tokens-w0bfag8o.css";
import "../../../assets/presentation/components/design-system/effects/border-radius-Ban4MabS.css";
import "../../../assets/presentation/components/design-system/effects/box-shadow-B5hOj7aO.css";
import "../../../assets/presentation/components/design-system/flexbox/flexbox-CakUPX3d.css";
import "../../../assets/presentation/components/design-system/spacing/margin-DSHMkLit.css";
import "../../../assets/presentation/components/design-system/spacing/padding-DREsqqDm.css";
import "../../../assets/presentation/components/design-system/spacing/width-height-l5J3zuUY.css";
import "../../../assets/presentation/components/design-system/typography/body-5-izFr62.css";
import "../../../assets/presentation/components/design-system/typography/buttons-BQwqjgQp.css";
import "../../../assets/presentation/components/design-system/typography/display-BlNoyoNs.css";
import "../../../assets/presentation/components/design-system/typography/headings-7hpWndI9.css";
import "../../../assets/presentation/components/design-system/typography/labels-lPKzPHrn.css";
import "../../../assets/presentation/components/design-system/typography/text-BsHvPgmc.css";
import "../../../assets/presentation/components/design-system/utils/component-utils-Cl8fG5qP.css";
/* empty css                  */
/* empty css                       */
/* empty css                    */
/* empty css                         */
/* empty css               */
/* empty css               */
/* empty css               */
/* empty css              */
/* empty css                      */
/* empty css                   */
/* empty css                */
/* empty css               */
/* empty css                */
/* empty css                     */
/* empty css                */
/* empty css                   */
/* empty css                   */
/* empty css                    */
/* empty css                  */
/* empty css                */
/* empty css                      */
//#region src/presentation/components/design-system/design-system.tsx
var DesignSystem = () => null;
//#endregion
export { DesignSystem };

//# sourceMappingURL=design-system.js.map